var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModel3DPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 482.797,
    height: 443.918,
    viewBox: "0 0 482.797 443.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11604",
    "data-name": "Group 11604",
    transform: "translate(5296.109 988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-hexagon",
    "data-name": "Icon feather-hexagon",
    d: "M154.334,119.523V52.931a16.648,16.648,0,0,0-8.324-14.4L87.741,5.234a16.648,16.648,0,0,0-16.648,0L12.824,38.53A16.648,16.648,0,0,0,4.5,52.931v66.593a16.648,16.648,0,0,0,8.324,14.4l58.269,33.3a16.648,16.648,0,0,0,16.648,0l58.269-33.3a16.648,16.648,0,0,0,8.324-14.4Z",
    transform: "translate(-5217.369 -991.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-hexagon-2",
    "data-name": "Icon feather-hexagon",
    d: "M154.334,119.523V52.931a16.648,16.648,0,0,0-8.324-14.4L87.741,5.234a16.648,16.648,0,0,0-16.648,0L12.824,38.53A16.648,16.648,0,0,0,4.5,52.931v66.593a16.648,16.648,0,0,0,8.324,14.4l58.269,33.3a16.648,16.648,0,0,0,16.648,0l58.269-33.3a16.648,16.648,0,0,0,8.324-14.4Z",
    transform: "translate(-5134.127 -852.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-hexagon-3",
    "data-name": "Icon feather-hexagon",
    d: "M154.334,119.523V52.931a16.648,16.648,0,0,0-8.324-14.4L87.741,5.234a16.648,16.648,0,0,0-16.648,0L12.824,38.53A16.648,16.648,0,0,0,4.5,52.931v66.593a16.648,16.648,0,0,0,8.324,14.4l58.269,33.3a16.648,16.648,0,0,0,16.648,0l58.269-33.3a16.648,16.648,0,0,0,8.324-14.4Z",
    transform: "translate(-5050.887 -991.003)",
    fill: "#812ef1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-hexagon-4",
    "data-name": "Icon feather-hexagon",
    d: "M154.334,119.523V52.931a16.648,16.648,0,0,0-8.324-14.4L87.741,5.234a16.648,16.648,0,0,0-16.648,0L12.824,38.53A16.648,16.648,0,0,0,4.5,52.931v66.593a16.648,16.648,0,0,0,8.324,14.4l58.269,33.3a16.648,16.648,0,0,0,16.648,0l58.269-33.3a16.648,16.648,0,0,0,8.324-14.4Z",
    transform: "translate(-5134.127 -852.268)",
    fill: "#812ef1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-hexagon-5",
    "data-name": "Icon feather-hexagon",
    d: "M154.334,119.523V52.931a16.648,16.648,0,0,0-8.324-14.4L87.741,5.234a16.648,16.648,0,0,0-16.648,0L12.824,38.53A16.648,16.648,0,0,0,4.5,52.931v66.593a16.648,16.648,0,0,0,8.324,14.4l58.269,33.3a16.648,16.648,0,0,0,16.648,0l58.269-33.3a16.648,16.648,0,0,0,8.324-14.4Z",
    transform: "translate(-4967.646 -852.268)",
    fill: "#812ef1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-hexagon-6",
    "data-name": "Icon feather-hexagon",
    d: "M154.334,119.523V52.931a16.648,16.648,0,0,0-8.324-14.4L87.741,5.234a16.648,16.648,0,0,0-16.648,0L12.824,38.53A16.648,16.648,0,0,0,4.5,52.931v66.593a16.648,16.648,0,0,0,8.324,14.4l58.269,33.3a16.648,16.648,0,0,0,16.648,0l58.269-33.3a16.648,16.648,0,0,0,8.324-14.4Z",
    transform: "translate(-5050.887 -713.533)",
    fill: "#812ef1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-hexagon-7",
    "data-name": "Icon feather-hexagon",
    d: "M154.334,119.523V52.931a16.648,16.648,0,0,0-8.324-14.4L87.741,5.234a16.648,16.648,0,0,0-16.648,0L12.824,38.53A16.648,16.648,0,0,0,4.5,52.931v66.593a16.648,16.648,0,0,0,8.324,14.4l58.269,33.3a16.648,16.648,0,0,0,16.648,0l58.269-33.3a16.648,16.648,0,0,0,8.324-14.4Z",
    transform: "translate(-5217.369 -713.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-hexagon-8",
    "data-name": "Icon feather-hexagon",
    d: "M154.334,119.523V52.931a16.648,16.648,0,0,0-8.324-14.4L87.741,5.234a16.648,16.648,0,0,0-16.648,0L12.824,38.53A16.648,16.648,0,0,0,4.5,52.931v66.593a16.648,16.648,0,0,0,8.324,14.4l58.269,33.3a16.648,16.648,0,0,0,16.648,0l58.269-33.3a16.648,16.648,0,0,0,8.324-14.4Z",
    transform: "translate(-5300.609 -852.268)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel3DPreview);
export default __webpack_public_path__ + "static/media/Model3dPreview.ce8dfc604fe0c32bc85cf9576b779005.svg";
export { ForwardRef as ReactComponent };